import noDataImage from "./no-records.svg"
import { ContentBox } from "web/components"
export default function EmptyPage({ message, children, classNames }) {
  return (
    <ContentBox
      className={`flex flex-col items-center justify-center text-center shadow ${
        classNames && classNames
      }`}
    >
      <img
        src={noDataImage}
        alt="No data to show"
        style={{ width: "50%", maxWidth: "250px" }}
      />
      <p className="mt-1 text-sm text-gray-500">{message}</p>
      {children}
    </ContentBox>
  )
}
